import { useAtomValue } from 'jotai';

import { useLockBodyScroll } from '@/shared/hooks/useLockBodyScroll';

import { aiGenerateDockInputShownAtom } from '../stores/aiGenerateDock.atoms';

const INERT_PROPS: Record<string, string> = { inert: '' };
const NO_PROPS: Record<string, string> = {};

export type AiGenerateDockBackgroundLockOptions = {
  enabled: boolean;
};

/**
 * 생성기 입력창이 펼쳐진 동안 뒤 화면을 잠근다(PRD 3-1) — 스크롤은 여기서 걸고, 클릭·포커스를 막을
 * inert 속성은 돌려줘 뒤 화면 루트에 붙이게 한다. 생성기(입력창)는 그 루트 밖에 둔다.
 * 잠금은 뒤 흐림과 같은 조건 — 입력창이 실제로 보일 때(aiGenerateDockInputShownAtom)다.
 * React 18.3.1 은 boolean inert 를 못 써서 BuildPageView 와 같은 빈 문자열 속성을 쓴다.
 */
export const useAiGenerateDockBackgroundLock = ({
  enabled,
}: AiGenerateDockBackgroundLockOptions) => {
  const inputShown = useAtomValue(aiGenerateDockInputShownAtom);
  const locked = enabled && inputShown;
  useLockBodyScroll(locked);
  return locked ? INERT_PROPS : NO_PROPS;
};
